import React, { useEffect, useState, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle2, ChevronDown, ShieldCheck, ArrowRight, Star } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 59,
    seconds: 59
  });
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Meta Pixel initialization & PageView
  useEffect(() => {
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '934990992774070');
    (window as any).fbq('track', 'PageView');
    document.title = 'Cookie Block 170 — The Blueprint';
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (link) {
      link.href = 'https://cdn.magicpatterns.com/uploads/t6Si9WYqfFVdJ5ty1Y5Pm4/heylloyd-image-1776829226333.png';
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = 'https://cdn.magicpatterns.com/uploads/t6Si9WYqfFVdJ5ty1Y5Pm4/heylloyd-image-1776829226333.png';
      document.head.appendChild(newLink);
    }
  }, []);
  const checkoutUrl = 'https://www.lanzadigital360.com/cart/48237486866657:1';
  const handleAddToCart = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Cookie Block 170 - The Blueprint',
        content_type: 'product',
        value: 17.0,
        currency: 'USD'
      });
    }
    setTimeout(() => {
      window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    }, 300);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-dark flex flex-col font-sans overflow-x-hidden" data-id="element-1">
      {/* URGENCY BAR */}
      <div className="sticky top-0 z-50 bg-gold text-black px-4 py-3 shadow-[0_4px_20px_rgba(197,165,90,0.2)]" data-id="element-2">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center sm:text-left" data-id="element-3">
          <div className="flex items-center gap-2 font-bold text-sm sm:text-base" data-id="element-4">
            <span className="animate-pulse" data-id="element-5">⚠️</span>
            ATENCIÓN: Solo 50 cupos disponibles para la preventa con 88% de
            descuento.
          </div>
          <div className="flex items-center gap-2 font-mono font-bold bg-black/10 px-3 py-1 rounded-md text-sm" data-id="element-6">
            <Clock size={16} data-id="element-7" />
            <span data-id="element-8">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-9">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_center,rgba(197,165,90,0.1),transparent_50%)] pointer-events-none" data-id="element-10" />

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-11">
          <motion.div initial="hidden" animate="visible" variants={staggerContainer} className="text-center flex flex-col items-center" data-id="element-12">
            <motion.img variants={fadeIn} src="https://cdn.magicpatterns.com/uploads/t6Si9WYqfFVdJ5ty1Y5Pm4/heylloyd-image-1776829226333.png" alt="Cookie Block 170 Logo" className="h-36 md:h-52 object-contain mb-8 drop-shadow-2xl" data-id="element-13" />

            <motion.h1 variants={fadeIn} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6 max-w-4xl" data-id="element-14">
              Cómo Facturar tus primeros{' '}
              <span className="text-gold italic" data-id="element-15">$2,000 USD al Mes</span>{' '}
              Horneando "Joyas" de 170 Gramos desde tu Propia Cocina.
            </motion.h1>

            <motion.p variants={fadeIn} className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl leading-relaxed" data-id="element-16">
              El Sistema "Cookie Block 170": Domina el Arte de las Galletas
              Estilo NY con Relleno Volcánico y Construye un Negocio de
              Repostería de Lujo Sin Maquinaria Industrial.
            </motion.p>

            <motion.div variants={fadeIn} className="w-full max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(197,165,90,0.15)] border border-white/10" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/5w8XvgztGndnZhDq1bQzFU/Gemini_Generated_Image_7fr0xm7fr0xm7fr0.png" alt="Galleta estilo NY partida a la mitad con relleno líquido" className="w-full h-auto object-cover object-top hover:scale-105 transition-transform duration-700" style={{
              maxHeight: '600px',
              objectPosition: 'center 30%'
            }} data-id="element-18" />
            </motion.div>

            <motion.button variants={fadeIn} onClick={scrollToPricing} className="bg-gold hover:bg-gold-light text-black font-bold text-lg md:text-xl px-8 py-4 rounded-full flex items-center gap-3 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(197,165,90,0.4)] cursor-pointer" data-id="element-19">
              SÍ, QUIERO EL BLUEPRINT AHORA <ArrowRight className="w-6 h-6" data-id="element-20" />
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* STORYTELLING */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-dark-surface border-y border-white/5" data-id="element-21">
        <div className="max-w-3xl mx-auto" data-id="element-22">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={staggerContainer} className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-23">
            <motion.p variants={fadeIn} data-id="element-24">
              ¿Te has fijado en cómo la mayoría de las pastelerías están
              muriendo intentando vender lo mismo de siempre? Cupcakes secos,
              galletas de supermercado y bizcochos que nadie quiere pagar a más
              de un dólar.
            </motion.p>
            <motion.p variants={fadeIn} data-id="element-25">
              Mientras tanto, en Nueva York y Londres, hay colas de dos cuadras
              para comprar{' '}
              <span className="text-white font-semibold" data-id="element-26">
                una sola galleta por $6 o $7 dólares.
              </span>
            </motion.p>
            <motion.p variants={fadeIn} className="text-xl font-serif text-gold italic border-l-4 border-gold pl-6 py-2 my-8" data-id="element-27">
              No es magia. Es ingeniería de alimentos.
            </motion.p>
            <motion.p variants={fadeIn} data-id="element-28">
              Yo estuve ahí, horneando postres genéricos que me dejaban agotada
              y con los bolsillos vacíos. Hasta que entendí que el mercado no
              quiere "dulces", el mercado quiere{' '}
              <strong className="text-white" data-id="element-29">
                experiencias visuales y sabores explosivos
              </strong>
              .
            </motion.p>
            <motion.p variants={fadeIn} data-id="element-30">
              Así nació el método de la galleta de 170 gramos: una masa masiva,
              una costra volcánica y un centro líquido que se vuelve viral cada
              vez que alguien lo parte frente a una cámara.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* SOLUTION & VALUE POINTS */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-31">
        <div className="max-w-5xl mx-auto" data-id="element-32">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16" data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-34">
              Presentamos:{' '}
              <span className="text-gold" data-id="element-35">
                COOKIE BLOCK 170 — THE BLUEPRINT
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-36">
              He resumido mis años de errores, pruebas de harina y desastres en
              el horno en un solo Blueprint paso a paso. No te voy a enseñar a
              cocinar; te voy a entregar las llaves de un negocio rentable que
              puedes empezar mañana mismo con lo que tienes en tu alacena.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-37">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} className="space-y-6" data-id="element-38">
              {[{
              title: 'La Fórmula de la Densidad',
              desc: 'Olvídate de las galletas planas. Aprenderás a conseguir los 4cm de altura que definen a una verdadera NY Cookie.'
            }, {
              title: 'Ingeniería de Rellenos Líquidos',
              desc: 'El secreto para que la Nutella o el Pistacho fluyan incluso 24 horas después del horneado.'
            }, {
              title: 'Maduración de 72 Horas',
              desc: 'El proceso químico que separa a los aficionados de los profesionales del sabor.'
            }, {
              title: 'Estrategia de Embalaje Premium',
              desc: 'Cómo hacer que tu caja de galletas parezca un producto de Apple y se venda a precio de oro.'
            }, {
              title: "Marketing de 'Foodporn'",
              desc: 'Las técnicas exactas para grabar videos que detengan el scroll y llenen tu bandeja de pedidos.'
            }].map((point, idx) => <motion.div key={idx} variants={fadeIn} className="flex gap-4 items-start bg-dark-surface p-6 rounded-xl border border-white/5 hover:border-gold/30 transition-colors" data-id="element-39">
                  <div className="bg-gold/10 p-2 rounded-full text-gold shrink-0 mt-1" data-id="element-40">
                    <CheckCircle2 size={24} data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <h3 className="text-white font-bold text-lg mb-2" data-id="element-43">
                      {point.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-44">
                      {point.desc}
                    </p>
                  </div>
                </motion.div>)}
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10" data-id="element-45">
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent z-10" data-id="element-46" />
              <img src="https://cdn.magicpatterns.com/uploads/1MwG7EBLu7smLqPezEYVPU/Gemini_Generated_Image_6i3chc6i3chc6i3c.png" alt="Variedad de galletas premium" className="w-full h-full object-cover" data-id="element-47" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* FOUNDERS STORY */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-dark-surface border-y border-white/5 relative overflow-hidden" data-id="element-48">
        <div className="max-w-6xl mx-auto" data-id="element-49">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={staggerContainer} className="text-center mb-16" data-id="element-50">
            <motion.p variants={fadeIn} className="text-gold uppercase tracking-[0.3em] text-sm mb-4 font-semibold" data-id="element-51">
              Conoce a los Fundadores
            </motion.p>
            <motion.h2 variants={fadeIn} className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-52">
              170 Gramos de <span className="text-gold italic" data-id="element-53">Ambición</span>
            </motion.h2>
            <motion.p variants={fadeIn} className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-54">
              La historia de Angel & Georgina — Donde la alquimia de la
              repostería se encuentra con el algoritmo del negocio.
            </motion.p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-55">
            <motion.div initial={{
            opacity: 0,
            x: -40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative rounded-2xl overflow-hidden shadow-2xl border border-gold/20" data-id="element-56">
              <img src="https://cdn.magicpatterns.com/uploads/pG9QtuWeyxk47s59wKjjcM/kling_20260507_作品_Cinematic__1461_0.png" alt="Angel y Georgina, fundadores de Cookie Block 170" className="w-full h-auto object-cover" data-id="element-57" />
            </motion.div>

            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} className="space-y-6 text-gray-300 leading-relaxed" data-id="element-58">
              <motion.p variants={fadeIn} data-id="element-59">
                En el corazón de un pequeño apartamento en Nueva York, entre el
                ruido de los taxis y la luz dorada que entraba por las ventanas
                industriales de un loft, nació algo más que una receta.{' '}
                <span className="text-white font-semibold" data-id="element-60">
                  Nació un imperio.
                </span>
              </motion.p>
              <motion.p variants={fadeIn} data-id="element-61">
                Hoy, Cookie Block 170 no es solo una marca de galletas. Es el
                resultado de dos latinos que decidieron que{' '}
                <span className="text-gold italic" data-id="element-62">"lo bueno"</span> no era
                suficiente.
              </motion.p>
            </motion.div>
          </div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-63">
            <motion.div variants={fadeIn} className="bg-dark border border-white/10 rounded-2xl p-8 hover:border-gold/30 transition-colors" data-id="element-64">
              <p className="text-gold uppercase tracking-widest text-xs font-bold mb-2" data-id="element-65">
                La Artista
              </p>
              <h3 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-66">
                Georgina
              </h3>
              <p className="text-gray-400 leading-relaxed mb-4" data-id="element-67">
                Para ella, la repostería no son solo medidas; es intuición. Pasó
                meses obsesionada con una sola idea: crear la galleta perfecta.
                Un "Bloque" masivo, una costra que crujiera al primer contacto y
                un centro de lava que desafiara la gravedad.
              </p>
              <p className="text-gray-300 leading-relaxed" data-id="element-68">
                Después de{' '}
                <span className="text-white font-bold" data-id="element-69">170 intentos</span> (de
                ahí el nombre), logró la "Maduración de 72 horas". Ella es el{' '}
                <span className="text-gold italic" data-id="element-70">Corazón</span> — la cara, la
                calidad y la pasión.
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="bg-dark border border-white/10 rounded-2xl p-8 hover:border-gold/30 transition-colors" data-id="element-71">
              <p className="text-gold uppercase tracking-widest text-xs font-bold mb-2" data-id="element-72">
                El Arquitecto
              </p>
              <h3 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-73">
                Angel
              </h3>
              <p className="text-gray-400 leading-relaxed mb-4" data-id="element-74">
                Nacido en NY, de raíces cubanas y boricuas, Angel siempre vio lo
                que otros ignoraban. Mientras Georgina cubría sus manos de
                harina, él cubría las pantallas de estrategia. Diseñó el sistema
                digital, el marketing y la logística que convirtieron la magia
                en un imperio.
              </p>
              <p className="text-gray-300 leading-relaxed" data-id="element-75">
                Él es la <span className="text-gold italic" data-id="element-76">Estructura</span> —
                el que convirtió un pasatiempo en una máquina de facturación.
              </p>
            </motion.div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="max-w-3xl mx-auto text-center border-t border-gold/20 pt-12" data-id="element-77">
            <p className="text-gold uppercase tracking-[0.3em] text-sm mb-6 font-semibold" data-id="element-78">
              El Manifiesto
            </p>
            <p className="text-xl md:text-2xl font-serif italic text-gray-200 leading-relaxed" data-id="element-79">
              "Nosotros ya cometimos los errores. Georgina quemó bandejas
              buscando el punto exacto y Angel perdió dinero ajustando los
              algoritmos. Hoy, te entregamos el{' '}
              <span className="text-gold" data-id="element-80">Blueprint maestro</span> para que tú
              no tengas que adivinar."
            </p>
            <p className="text-gray-400 mt-6 italic" data-id="element-81">
              Ella te enseña la magia; él te enseña el negocio.
            </p>
          </motion.div>
        </div>
      </section>

      {/* VALUE STACK & PRICING */}
      <section id="oferta" className="py-24 px-4 sm:px-6 lg:px-8 bg-dark relative overflow-hidden" data-id="element-82">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(ellipse_at_top,rgba(197,165,90,0.15),transparent_70%)] pointer-events-none" data-id="element-83" />

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-84">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="bg-dark border border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(197,165,90,0.1)]" data-id="element-85">
            <motion.div variants={fadeIn} className="text-center mb-10" data-id="element-86">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-87">
                Todo lo que te llevas hoy
              </h2>
              <div className="inline-block bg-red-600 text-white font-bold text-lg px-6 py-2 rounded-full mt-2" data-id="element-88">
                🔥 OFERTA DEL 88% DE DESCUENTO
              </div>
            </motion.div>

            <motion.div variants={fadeIn} className="space-y-4 mb-10" data-id="element-89">
              {[{
              icon: '📘',
              title: 'La Guía Cookie Block 170'
            }, {
              icon: '🔥',
              title: 'Recetario de Rellenos Volcánicos'
            }, {
              icon: '🧮',
              title: 'Guía para obtener el costo de tu galleta y cobrar correctamente'
            }].map((item, idx) => <div key={idx} className="flex items-center gap-3 p-4 bg-dark-surface rounded-lg border border-white/5" data-id="element-90">
                  <span className="text-2xl" data-id="element-91">{item.icon}</span>
                  <span className="font-medium text-gray-200" data-id="element-92">
                    {item.title}
                  </span>
                </div>)}
            </motion.div>

            <motion.div variants={fadeIn} className="text-center" data-id="element-93">
              <p className="text-gray-400 mb-2" data-id="element-94">
                PRECIO REGULAR: <span className="line-through" data-id="element-95">$141.00</span>
              </p>
              <p className="text-xl text-gold font-bold mb-4" data-id="element-96">
                HOY, ACCESO COMPLETO POR SOLO:
              </p>
              <div className="text-6xl md:text-7xl font-serif font-bold text-white mb-6 drop-shadow-lg" data-id="element-97">
                $17<span className="text-3xl text-gray-400" data-id="element-98">.00 USD</span>
              </div>
              <p className="text-sm text-gray-400 mb-8 italic" data-id="element-99">
                (Menos de lo que ganarás vendiendo tus primeras 3 galletas)
              </p>

              <a href="https://www.lanzadigital360.com/cart/48237486866657:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full md:w-auto bg-gold hover:bg-gold-light text-black font-bold text-xl px-10 py-5 rounded-full flex items-center justify-center gap-3 mx-auto transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(197,165,90,0.3)] no-underline" data-id="element-100">
                ACCESO INMEDIATO AHORA <ArrowRight className="w-6 h-6" data-id="element-101" />
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="max-w-5xl mx-auto" data-id="element-103">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-14" data-id="element-104">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-105">
              Lo que dicen nuestras <span className="text-gold" data-id="element-106">alumnas</span>
            </h2>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="grid md:grid-cols-3 gap-6" data-id="element-107">
            {[{
            name: 'María Fernanda R.',
            location: 'Miami, Florida',
            text: 'Empecé vendiendo galletas a $1 y no entendía por qué nadie las valoraba. Con el método Cookie Block 170 ahora vendo cada galleta a $5 y tengo lista de espera. ¡En mi primer mes facturé $1,800!'
          }, {
            name: 'Valentina G.',
            location: 'Houston, Texas',
            text: 'La guía de cálculo es maravillosa porque me ayudó a cobrar de la manera correcta. Estaba regalando mi trabajo, y el trabajo del baker no es sencillo. ¡Gracias Georgina!'
          }, {
            name: 'Carolina M.',
            location: 'Los Angeles, California',
            text: 'Los rellenos volcánicos son un antes y un después. Cada vez que publico un video partiendo la galleta, me llueven los pedidos. Ya dejé mi trabajo y me dedico 100% a mi negocio de cookies.'
          }].map((testimonial, idx) => <motion.div key={idx} variants={fadeIn} className="bg-dark-surface border border-white/5 rounded-2xl p-6 flex flex-col hover:border-gold/20 transition-colors" data-id="element-108">
                <div className="flex gap-1 mb-4" data-id="element-109">
                  {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} size={18} className="fill-gold text-gold" data-id="element-110" />)}
                </div>
                <p className="text-gray-300 leading-relaxed mb-6 flex-1 italic" data-id="element-111">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-white/5 pt-4" data-id="element-112">
                  <p className="font-bold text-white" data-id="element-113">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-114">
                    {testimonial.location}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="max-w-3xl mx-auto text-center" data-id="element-116">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="flex flex-col items-center" data-id="element-117">
            <ShieldCheck className="w-20 h-20 text-gold mb-6" data-id="element-118" />
            <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-119">
              GARANTÍA DE HIERRO DE 7 DÍAS
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-120">
              Pruébalo por 7 días. Si horneas tu primera tanda siguiendo mi
              método y tus galletas no son las más impresionantes que has visto
              en tu vida, te devuelvo el 100% de tu dinero. Sin preguntas.{' '}
              <strong className="text-white" data-id="element-121">El riesgo es todo mío.</strong>
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-dark-surface border-t border-white/5" data-id="element-122">
        <div className="max-w-3xl mx-auto" data-id="element-123">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-12" data-id="element-124">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-125">
              Preguntas Frecuentes
            </h2>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="space-y-4" data-id="element-126">
            {[{
            q: '¿Necesito una batidora KitchenAid?',
            a: 'No. Te enseño a hacerlo a mano o con batidoras económicas sin quemarlas.'
          }, {
            q: '¿Puedo venderlas si no sé de marketing?',
            a: 'Te doy los textos y las ideas de videos listas para copiar.'
          }, {
            q: '¿Los ingredientes son caros?',
            a: 'Son premium, pero el margen de ganancia es tan alto (600%) que se pagan solos.'
          }].map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-127" />)}
          </motion.div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-128">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(197,165,90,0.1),transparent_70%)] pointer-events-none" data-id="element-129" />
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-130">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-131">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-10" data-id="element-132">
              Es hora de dejar de vender a centavos y empezar a vender{' '}
              <span className="text-gold italic" data-id="element-133">experiencias</span>.
            </h2>
            <a href="https://www.lanzadigital360.com/cart/48237486866657:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="bg-gold hover:bg-gold-light text-black font-bold text-xl px-10 py-5 rounded-full inline-flex items-center justify-center gap-3 transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(197,165,90,0.4)] no-underline" data-id="element-134">
              🚀 SÍ, QUIERO CONSTRUIR MI IMPERIO COOKIE BLOCK 170
            </a>
          </motion.div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 text-center border-t border-white/5 text-gray-500 text-sm space-y-3" data-id="element-135">
        <div className="flex items-center justify-center gap-4" data-id="element-136">
          <button onClick={() => setShowTerms(true)} className="underline hover:text-gold transition-colors" data-id="element-137">
            Términos y Condiciones
          </button>
          <span data-id="element-138">|</span>
          <button onClick={() => setShowPrivacy(true)} className="underline hover:text-gold transition-colors" data-id="element-139">
            Política de Privacidad
          </button>
        </div>
        <p data-id="element-140">
          © {new Date().getFullYear()} Cookie Block 170. Todos los derechos
          reservados.
        </p>
      </footer>

      {/* TERMS MODAL */}
      {showTerms && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setShowTerms(false)} data-id="element-141">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-dark-surface border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-142">
            <div className="flex justify-between items-center mb-6" data-id="element-143">
              <h3 className="text-2xl font-serif font-bold text-white" data-id="element-144">
                Términos y Condiciones
              </h3>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-white text-2xl" data-id="element-145">
                &times;
              </button>
            </div>
            <div className="text-gray-300 space-y-4 text-sm leading-relaxed" data-id="element-146">
              <p data-id="element-147">
                <strong className="text-white" data-id="element-148">
                  1. Aceptación de los Términos
                </strong>
                <br data-id="element-149" />
                Al adquirir Cookie Block 170 — The Blueprint, aceptas estos
                términos y condiciones en su totalidad. Este producto es un
                recurso digital educativo.
              </p>
              <p data-id="element-150">
                <strong className="text-white" data-id="element-151">2. Producto Digital</strong>
                <br data-id="element-152" />
                Cookie Block 170 es un producto digital (ebook/guía) que se
                entrega de forma inmediata tras la compra. No se realizan envíos
                físicos.
              </p>
              <p data-id="element-153">
                <strong className="text-white" data-id="element-154">3. Uso Personal</strong>
                <br data-id="element-155" />
                El contenido adquirido es para uso personal y no comercial.
                Queda prohibida la reproducción, distribución o reventa del
                material sin autorización expresa.
              </p>
              <p data-id="element-156">
                <strong className="text-white" data-id="element-157">
                  4. Garantía de Devolución
                </strong>
                <br data-id="element-158" />
                Ofrecemos una garantía de devolución de 7 días. Si no estás
                satisfecho con el producto, puedes solicitar un reembolso
                completo dentro de los primeros 7 días posteriores a la compra.
              </p>
              <p data-id="element-159">
                <strong className="text-white" data-id="element-160">5. Resultados</strong>
                <br data-id="element-161" />
                Los resultados mencionados en la página de venta son ejemplos y
                no garantizan ingresos específicos. Los resultados dependen del
                esfuerzo, dedicación y circunstancias individuales de cada
                persona.
              </p>
              <p data-id="element-162">
                <strong className="text-white" data-id="element-163">6. Modificaciones</strong>
                <br data-id="element-164" />
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Las modificaciones serán efectivas desde su
                publicación.
              </p>
            </div>
          </motion.div>
        </div>}

      {/* PRIVACY MODAL */}
      {showPrivacy && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setShowPrivacy(false)} data-id="element-165">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-dark-surface border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-166">
            <div className="flex justify-between items-center mb-6" data-id="element-167">
              <h3 className="text-2xl font-serif font-bold text-white" data-id="element-168">
                Política de Privacidad
              </h3>
              <button onClick={() => setShowPrivacy(false)} className="text-gray-400 hover:text-white text-2xl" data-id="element-169">
                &times;
              </button>
            </div>
            <div className="text-gray-300 space-y-4 text-sm leading-relaxed" data-id="element-170">
              <p data-id="element-171">
                <strong className="text-white" data-id="element-172">
                  1. Información que Recopilamos
                </strong>
                <br data-id="element-173" />
                Recopilamos información personal como nombre, correo electrónico
                y datos de pago necesarios para procesar tu compra.
              </p>
              <p data-id="element-174">
                <strong className="text-white" data-id="element-175">2. Uso de la Información</strong>
                <br data-id="element-176" />
                Tu información se utiliza exclusivamente para procesar tu
                pedido, enviarte el producto digital y comunicarnos contigo
                sobre tu compra.
              </p>
              <p data-id="element-177">
                <strong className="text-white" data-id="element-178">3. Protección de Datos</strong>
                <br data-id="element-179" />
                Implementamos medidas de seguridad para proteger tu información
                personal. No almacenamos datos de tarjetas de crédito en
                nuestros servidores.
              </p>
              <p data-id="element-180">
                <strong className="text-white" data-id="element-181">4. Terceros</strong>
                <br data-id="element-182" />
                No vendemos, intercambiamos ni transferimos tu información
                personal a terceros, excepto a proveedores de servicios de pago
                necesarios para completar la transacción.
              </p>
              <p data-id="element-183">
                <strong className="text-white" data-id="element-184">5. Cookies</strong>
                <br data-id="element-185" />
                Utilizamos cookies para mejorar tu experiencia de navegación y
                analizar el tráfico del sitio. Puedes desactivar las cookies en
                la configuración de tu navegador.
              </p>
              <p data-id="element-186">
                <strong className="text-white" data-id="element-187">6. Contacto</strong>
                <br data-id="element-188" />
                Si tienes preguntas sobre nuestra política de privacidad, puedes
                contactarnos a través de nuestras redes sociales o correo
                electrónico.
              </p>
            </div>
          </motion.div>
        </div>}
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div variants={fadeIn} className="border border-white/10 rounded-xl overflow-hidden bg-dark" data-id="element-189">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-190">
        <span className="font-bold text-lg text-white pr-8" data-id="element-191">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-192" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} className="overflow-hidden" data-id="element-193">
        <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-194">
          {answer}
        </div>
      </motion.div>
    </motion.div>;
}